import React from "react";
import { useAppSelector } from "store/hooks";
import { Navigate } from "react-router-dom";
import LoadingImage from "components/LoadingImage";

interface AuthGuardProps {
  children: React.ReactNode;
  requireOrg?: boolean;
  requireMentor?: boolean;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, requireOrg, requireMentor }) => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const user = useAppSelector((state) => state.auth.user_me);
  const isUserLoading = useAppSelector((state) => state.auth.isUserLoading);

  // loading user state
  if (isUserLoading || (isLoggedIn && user === null)) {
    return <LoadingImage className="min-h-[100vh] flex items-center justify-center" />;
  }

  // logged in route protection
  if (!isLoggedIn) {
    return <>
      <LoadingImage className="min-h-[100vh] flex items-center justify-center" />
      <Navigate to={`/?login&forward=${window.location.pathname}`} replace />
    </>;
  }

  // recruiter route protection, if needed
  if (requireOrg && !(user && user._organizations && user._organizations.length > 0)) {
    return <>
      <LoadingImage className="min-h-[100vh] flex items-center justify-center" />
      <Navigate to="/error-404" replace />
    </>;
  }

  // mentor route protection, if needed
  if (requireMentor && !user._mentor) {
    return <>
      <LoadingImage className="min-h-[100vh] flex items-center justify-center" />
      <Navigate to="/error-404" replace />
    </>;
  }

  return <>{children}</>;
};

export default AuthGuard; 